export default __webpack_public_path__ + "assets/images/2d0e3c540f74e7130890594c0de7184e.png";